import React from 'react';
import PropTypes from 'prop-types';
import { Container, Label } from './css';

const PrimaryButton = ({
  label, size, showArrow = true, children, fill, ...rest
}) => (
  <Container fill={fill} onMouseUp={(e) => e.target.blur()} showarrow={showArrow.toString()} {...rest}>
    <Label size={size} showarrow={showArrow.toString()}>{label || children}</Label>
  </Container>
);

PrimaryButton.propTypes = {
  label: PropTypes.string,
  size: PropTypes.string,
  showArrow: PropTypes.bool,
  children: PropTypes.node,
  fill: PropTypes.bool,
};

export default PrimaryButton;
